module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-800italic.fefe4ff.woff";